export const initialState = {
  firstName: '',
  lastName: '',
  isPrimary: false,
  email: '',
  phone: '',
  phoneType: '',
  dateOfBirth: null,
  sex: null,
  relationship: null,
  livesWithPatient: false,
  medicareStatus: null,
  mbi: '',
  roleYears: null,
  roleMonths: null,
  preferredLanguage: null,
  techComfortLevel: null,
};
